import { useState } from "react";
import useFetch from "./hooks/useFetch";
import Loading from "../../../components/Loading";
import soporte_icono from "../../../assets/vw/svg/soporte.svg";
import SEARCH from "../../../assets/vw/svg/search.svg";
import CLOSE from "../../../assets/vw/svg/icon-close.svg"
import DropDownInput from "../../../components/DropdownInput";
import DropdownSearch from "../../../components/DropdownSearch";
import success_icono from "../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../assets/vw/svg/cerrar.svg";
import Menu from "../../../components/Menu";
import { Resumen } from "./components/Resumen";
import './css/index.css';
import { Checklist } from "./components/Checklist";



const SoporteAakdigital = ({ servicio }) => {
  const [generalFetch] = useFetch();
  const [loading, setLoading] = useState({
    isloading: false,
    messageLoading: "",
  });
  const [vin, setVin] = useState("");
  const [status, setStatus] = useState("");
  const [modalError, setModalError] = useState({
    open: false,
    title: "",
    message: "",
  });
  const [infoVin, setInfoVin] = useState(null);
  const [infoVinDatabase, setInfoVinDatabase] = useState({
    active: [],
    delivered: [],
  });
  const [statusCount, setStatusCount] = useState(null);

  let deliveryTypes = {
    USADO: 'usado',
    NUEVO_DEMO: 'nuevodemo',
    NUEVO: 'nuevo',
    DEMO: 'demo'
  };



  const [option, setOption] = useState("proceso");
  const statusCat = [
    "Entregado",
    "Error NADIN",
    "Error SFDC",
    "Error SFDC NADIN",
    "En proceso",
    "Enviando",
  ];

  const onOptionChangeHandler = (event) => {
    const valor = event.props.value;
    setStatus(valor);
  };

  const obtenerInfoVin = async () => {
    if (vin.length === 0) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message: "No ha ingresado el VIN.",
      });
      return 0;
    }
    if (vin.length !== 17 && vin.includes(" ")) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message:
          "El tamaño del VIN es incorrecto, debe contener 17 caracteres y no puede contener espacios.",
      });
      return 0;
    }

    if (vin.length !== 17) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message:
          "El tamaño del VIN es incorrecto, debe contener 17 caracteres.",
      });
      return 0;
    }

    if (vin.includes(" ")) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message: "El VIN no puede contener espacios.",
      });
      return 0;
    }

    let reg = /^[a-zA-Z0-9]*$/;
    if (!vin.match(reg)) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message: "El VIN no puede contener caracteres especiales",
      });
      return 0;
    }

    setLoading({
      isloading: true,
      messageLoading: "Obteniendo información del VIN...",
    });

    const response = await generalFetch("soporte/admin?vin=" + vin, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + servicio.getToken(),
      },
    });
    setLoading({ isloading: false, messageLoading: "" });
    if (!response.error && response.code === 200) {
      let entregaInfoResponse = response.body.mensaje

      let vinActive = entregaInfoResponse.database.filter((entrega) => entrega.estatusEntrega !== 'Entregado');
      let vinDelivered = entregaInfoResponse.database.filter((entrega) => entrega.fechaEntrega !== null && entrega.estatusEntrega === 'Entregado');
      setInfoVin(entregaInfoResponse);
      setInfoVinDatabase({
        active: vinActive,
        delivered: vinDelivered,
      });

      const keyMap = {
        "Entregado": "entregado",
        "Error NADIN": "errorNADIN",
        "Error SFDC": "errorSFDC",
        "Error SFDC NADIN": "errorSFDCNADIN",
        "En proceso": "enProceso",
        "Enviando": "enviando",
      };

      const count = {};
      Object.values(keyMap).forEach(key => {
        count[key] = 0;
      });
      entregaInfoResponse.database.forEach(item => {
        const originalStatus = item.estatusEntrega;
        const mappedKey = keyMap[originalStatus];
        if (mappedKey) {
          count[mappedKey]++;
        }
      });
      setStatusCount(count);
    } else {
      setModalError({
        open: true,
        title: "¡Error!",
        message:
          "message" in response
            ? response.message
            : "mensaje" in response.body
              ? response?.body?.mensaje
              : response.body.message,
      });
    }
  };

  const actualizarEstatus = async () => {
    if (infoVinDatabase.active.length !== 1) {
      setModalError(
        {
          open: true,
          title: '¡Error!',
          message: `Debe de haber una entrega en proceso para actualizar el estatus.`
        }
      );
      return;
    }

    if (status.length === 0) {
      setModalError({
        open: true,
        title: "¡Advertencia!",
        message: "Seleccione primero un estatus.",
      });
      return;
    }
    setLoading({
      isloading: true,
      messageLoading: "Actualizando fecha de la entrega...",
    });
    const response = await generalFetch("soporte/admin", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + servicio.getToken(),
      },
      body: JSON.stringify({
        idEntrega: infoVinDatabase.active[0].idEntrega,
        nuevoEstatus: status,
      }),
    });
    setLoading({ isloading: false, messageLoading: "" });
    if (!response.error && response.code === 200) {
      setModalError({
        open: true,
        title: "¡Éxito!",
        message: response.body.mensaje,
      });
    } else {
      setModalError({
        open: true,
        title: "¡Error!",
        message:
          "message" in response ? response.message : response?.body?.mensaje,
      });
    }
  };

  const enviarFechaSF = async () => {
    if (infoVinDatabase.active.length !== 1) {
      setModalError(
        {
          open: true,
          title: '¡Error!',
          message: `Debe de haber una entrega en proceso para enviar la fecha de entrega a Salesforce.`
        }
      );
      return;
    }
    setLoading({
      isloading: true,
      messageLoading: "Enviando fecha de entrega a Salesforce...",
    });
    const response = await generalFetch("soporte/admin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + servicio.getToken(),
      },
      body: JSON.stringify({
        enviarSF: true,
        idEntrega: infoVinDatabase.active[0].idEntrega,
      }),
    });
    setLoading({ isloading: false, messageLoading: "" });
    if (!response.error && response.code === 200) {
      setModalError({
        open: true,
        title: "¡Éxito!",
        message: response.body.mensaje,
      });
    } else {
      setModalError({
        open: true,
        title: "¡Error!",
        message:
          "message" in response ? response.message : response?.body?.mensaje,
      });
    }
  };

  const enviarFechaNadin = async () => {
    setLoading({
      isloading: true,
      messageLoading: "Enviando fecha de entrega a NADIN...",
    });
    const response = await generalFetch("soporte/admin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + servicio.getToken(),
      },
      body: JSON.stringify({
        enviarNADIN: true,
        idEntrega: infoVinDatabase.active?.[0]?.idEntrega
          ?? infoVinDatabase.delivered?.[0]?.idEntrega,
      }),
    });
    setLoading({ isloading: false, messageLoading: "" });
    if (!response.error && response.code === 200) {
      setModalError({
        open: true,
        title: "¡Éxito!",
        message: response.body.mensaje,
      });
    } else {
      setModalError({
        open: true,
        title: "¡Error!",
        message:
          "message" in response ? response.message : response?.body?.mensaje,
      });
    }
  };


  const changeOption = (option) => {
    setOption(option);
  };

  const buildContent = () => {
    return (
      <>
        {modalError.title === "¡Éxito!" ? (
          <div className="mt-2 px-2 mensaje_confirmacion mb-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="d-flex justify-content-center">
              {modalError.message}
            </label>
          </div>
        ) : (
          <div className="mt-2 px-2 mensaje_confirmacion mb-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="d-flex justify-content-center">
              {modalError.message}
            </label>
          </div>
        )}
      </>
    );
  };

  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw fade ${modalError.open ? "show" : ""}`}
        id="desarchivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="desarchivarLabel"
        style={modalError.open ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModalError({
                    open: false,
                    title: '',
                    message: ''
                  })}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-5`}>
              {buildContent()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Menu />
      {loading.isloading && <Loading />}
      <div className={`navegacion`}>
        <div className="row posicionMenu ml-1">
          <div className={`titulo_vw p-0 ml-1 pb-3`}>
            <img
              src={soporte_icono}
              alt="soporte"
              className="icono-menu me-3"
            />
            Soporte Aak Digital
          </div>
        </div>
        <div className="row border_vw pt-4 mx-1"></div>
        <div className="navegacion-items">
          <div className="nav-input">
            <div className="py-2 w-100">
              <div className="m-0 p-0 vin-container">
                <div className="d-flex align-items-center  rounded px-2" style={{ height: "40px" }}>
                  <span className="me-2">
                    <img src={SEARCH} alt="buscar" className="icono-menu" />
                  </span>
                  <input
                    className="input_vw_soporte flex-grow-1 border-0"
                    value={vin}
                    onChange={({ target }) => {
                      setVin(target.value.trim().toUpperCase());
                    }}
                    onKeyDown={async (e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        await obtenerInfoVin();
                      }
                    }}
                    placeholder="VIN"
                    style={{ outline: 'none' }}
                  />
                  {vin.length > 0 && (
                    <span
                      className="ms-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => setVin("")}
                    >
                      <img src={CLOSE} alt="cerrar" className="icono-close" />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          {infoVin && (
            <div className="resumen-container">
              <p className="text-resumen">Resumen general</p>
              <div className="resumen-items">
                <Resumen type={'entregado'} cantidad={statusCount?.entregado} />
                <Resumen type={'en-proceso'} cantidad={statusCount?.enProceso} />
                <Resumen type={'error-nadin'} cantidad={statusCount?.errorNADIN} />
                <Resumen type={'error-sfdc'} cantidad={statusCount?.errorSFDC} />
                <Resumen type={'error-nadin-sfdc'} cantidad={statusCount?.errorSFDCNADIN} />
              </div>
            </div>
          )}
        </div>
        {infoVin && (
          <Checklist servicio={servicio} item={infoVin} checklist={infoVin.checklist} />
        )}
        {infoVin && (
          <div className="py-5">
            <div className="flex-column flex-md-row d-flex w-100 gap-1 flex-wrap justify-content-between">
              <div className="box-soporte flex-grow-1">
                <div className="mb-4 mb-lg-0 px-0">
                  <div className="d-flex justify-content-center align-items-center title_soporte">
                    Base de datos
                  </div>
                  <div className="container_soporte">
                    <div className='respuesta__navigation'>
                      <button
                        className={`respuesta__navigation__btn ${option === "proceso" ? 'active' : ''}`}
                        onClick={() => { changeOption("proceso") }}
                      >En proceso</button>
                      <button
                        className={`respuesta__navigation__btn ${option === "entregado" ? 'active' : ''}`}
                        onClick={() => { changeOption("entregado") }}
                      >Entregados</button>
                    </div>
                    {
                      option === "proceso" && (
                        infoVinDatabase.active.length > 0 ? (
                          <>
                            <div className="container_soporte_resultado mx-3">
                              <pre className="p-4" style={{
                                color: '#E7E7E7'
                              }}>
                                {JSON.stringify(infoVinDatabase.active, null, 2)}
                              </pre>
                            </div>
                            <div className="row mt-4 mx-3 drop-base-datos" style={{ color: '#E7E7E7', fontFamily: 'vwRegular' }}>
                              <DropdownSearch
                                menu={statusCat.map((ele, index) => {
                                  return {
                                    nombre: ele
                                  }
                                })}
                                title={"Estatus de entrega"}
                                defaultValue={status}
                                handleOptionSelected={onOptionChangeHandler}
                                fieldID={'nombre'}
                                fieldToShow={'nombre'}
                              />
                            </div>
                            <div className="d-flex justify-content-center boton-base-actualizar">
                              <button
                                type="button"
                                className="button_vw_soporte button_vw--primary"
                                onClick={async () => await actualizarEstatus()}
                                disabled={
                                  !(infoVin.database && infoVinDatabase.active.length > 0)
                                }
                              >
                                Actualizar
                              </button>
                            </div>
                          </>
                        ) : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff', fontFamily: 'vwRegular' }}>
                          <p>No hay entregas con estatus en proceso.</p>
                        </div>
                      )
                    }
                    {
                      option === "entregado" && (
                        infoVinDatabase.delivered.length > 0 ? (
                          <div className="container_soporte_resultado resultado_largo mx-3">
                            <pre className=" p-4" style={{ color: '#E7E7E7' }}>
                              {JSON.stringify(infoVinDatabase.delivered, null, 2)}
                            </pre>
                          </div>
                        ) : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff', fontFamily: 'vwRegular' }}>
                          <p>No hay entregas entregadas.</p>
                        </div>
                      )
                    }
                  </div>
                </div>
              </div>
              <div className="box-soporte flex-grow-1">
                <div className="mb-4 mb-lg-0 px-0">
                  <div className="d-flex justify-content-center align-items-center title_soporte nadin">
                    <p className="nadin-title">NADIN</p>
                    <div className="contador-nadin">
                      <p>{infoVin.nadin?.length}</p>
                    </div>
                  </div>
                  <div className="container_soporte">
                    <div className="container_soporte_resultado resultado_largo m-3">
                      <pre className="p-4" style={{
                        color: '#E7E7E7'
                      }}>
                        {JSON.stringify(infoVin.nadin, null, 2)}
                      </pre>
                    </div>
                    <div className="d-flex justify-content-center">
                      <button
                        className="button_vw_fecha button_vw--primary "
                        onClick={async () => await enviarFechaNadin()}
                        disabled={
                          !(
                            (infoVin.nadin &&
                              Array.isArray(infoVin.nadin) &&
                              infoVin.nadin.length > 0 &&

                              infoVinDatabase.active.length > 0 &&
                              infoVinDatabase.active[0].fechaEntrega !== null &&

                              (infoVinDatabase.active[0].tipoEntrega === deliveryTypes.NUEVO || infoVinDatabase.active[0].tipoEntrega === deliveryTypes.DEMO)
                            )
                            ||
                            (
                              infoVin.nadin &&
                              Array.isArray(infoVin.nadin) &&
                              infoVin.nadin.length > 0 &&

                              infoVinDatabase.delivered.length > 0 &&

                              infoVinDatabase.delivered[0].estatusEntrega === "Entregado" &&
                              infoVin.nadin[0]?.deliverycustomerdate === ""
                            )
                          )
                        }
                      >
                        Enviar fecha de entrega
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="box-soporte flex-grow-1">
                <div className="mb-5 mb-lg-0 pb-5 px-0">
                  <div className="d-flex justify-content-center align-items-center title_soporte">
                    Salesforce
                  </div>
                  <div className="container_soporte">
                    <div className="container_soporte_resultado resultado_largo m-3">
                      <pre className="p-4" style={{ color: '#E7E7E7', }}>
                        {JSON.stringify(infoVin.salesforce, null, 2)}
                      </pre>
                    </div>
                    <div className="d-flex justify-content-center">
                      <button
                        className="button_vw_fecha button_vw--primary"
                        onClick={async () => await enviarFechaSF()}
                        disabled={
                          !(infoVin.salesforce && typeof (infoVin.salesforce) === "object" &&
                            Object.keys(infoVin.salesforce).length > 0 && infoVin.salesforce.IdProcesoDeVenta !== null &&
                            infoVinDatabase.active.length > 0 && infoVinDatabase.active[0].fechaEntrega !== null &&
                            (infoVinDatabase.active[0].tipoEntrega === deliveryTypes.NUEVO || infoVinDatabase.active[0].tipoEntrega === deliveryTypes.USADO || infoVinDatabase.active[0].tipoEntrega === deliveryTypes.NUEVO_DEMO)
                          )
                        }
                      >
                        Enviar fecha de entrega
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
      {buildPopUp()}
    </>
  );
};

export default SoporteAakdigital;
